import { apiRequest } from '../utils/api';
import { getApiEndpoint } from '../config/api';
import { getAuthHeader } from '../utils/auth';

const BASE = '/api/onboarding-wizard';

export const listSessions = (propertyId) =>
  apiRequest(`${BASE}/properties/${propertyId}/sessions`);

export const createSession = (propertyId, payload) =>
  apiRequest(`${BASE}/properties/${propertyId}/sessions`, { method: 'POST', body: JSON.stringify(payload) });

export const getSession = (sessionId) =>
  apiRequest(`${BASE}/sessions/${sessionId}`);

export const patchSession = (sessionId, patch) =>
  apiRequest(`${BASE}/sessions/${sessionId}`, { method: 'PATCH', body: JSON.stringify(patch) });

export const deleteSession = (sessionId) =>
  apiRequest(`${BASE}/sessions/${sessionId}`, { method: 'DELETE' });

export const savePins = (sessionId, pins) =>
  apiRequest(`${BASE}/sessions/${sessionId}/pins/bulk`, { method: 'POST', body: JSON.stringify({ pins }) });

export const createCategory = (sessionId, payload) =>
  apiRequest(`${BASE}/sessions/${sessionId}/categories`, { method: 'POST', body: JSON.stringify(payload) });

export const updateCategory = (categoryId, payload) =>
  apiRequest(`${BASE}/categories/${categoryId}`, { method: 'PUT', body: JSON.stringify(payload) });

export const deleteCategory = (categoryId) =>
  apiRequest(`${BASE}/categories/${categoryId}`, { method: 'DELETE' });

export const previewIds = (sessionId) =>
  apiRequest(`${BASE}/sessions/${sessionId}/id-preview`, { method: 'POST', body: JSON.stringify({}) });

export const setPropertyCode = (propertyId, code) =>
  apiRequest(`${BASE}/properties/${propertyId}/property-code`, { method: 'PUT', body: JSON.stringify({ property_code: code }) });

export const uploadPlan = async (propertyId, sessionId, file, meta = {}) => {
  const form = new FormData();
  form.append('plan', file);
  if (meta.title) form.append('title', meta.title);
  if (meta.level_name) form.append('level_name', meta.level_name);
  if (meta.notes) form.append('notes', meta.notes);
  const url = getApiEndpoint(`${BASE}/properties/${propertyId}/sessions/${sessionId}/upload-plan`);
  const res = await fetch(url, { method: 'POST', headers: { ...getAuthHeader() }, body: form });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Upload failed (${res.status})`);
  return data;
};
